@if (!networkStatusService.isOnline()) {
  <tt-banner [icon]="'wifi-off'" [size]="'small'" [type]="'neutral'">
    {{ 'Offline.OfflineBanner.Message' | transloco }}
  </tt-banner>
} @else {
  <tt-banner [icon]="'wifi'" [size]="'small'" [type]="'success'">
    <div class="tt-offline-page_banner">
      <span class="tt-offline-page_banner-content">
        {{ 'Offline.OnlineBanner.Message1' | transloco }}
        <a class="tt-offline-page_banner-link" [routerLink]="'/'">{{ 'Offline.OnlineBanner.Link' | transloco }}</a>
        {{ 'Offline.OnlineBanner.Message2' | transloco }}
      </span>
    </div>
  </tt-banner>
}

<div class="tt-offline-page_content">
  <router-outlet />
</div>
